import React from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { alpha, styled } from '@mui/material/styles';
import cx from 'classnames';
import parse from 'html-react-parser';

import FacebookIcon from '../../assets/icons/FacebookIcon';
import InstagramIcon from '../../assets/icons/InstagramIcon';
import LinkedInIcon from '../../assets/icons/LinkedInIcon';
import TwitterIcon from '../../assets/icons/TwitterIcon';
import { BREAKPOINTS_VALUES, colorsPalette, SMALL_MARGIN } from '../../theme';
import IKImage from '../IKImage/IKImage';
import useStyles from './styles';

enum SocialItemTypes {
  Telephone = 'telephone',
  Email = 'email',
  SocialMedia = 'socialMedia',
}

const ContactDetailsBlock = ({ data: blockData, tenant }) => {
  const background = blockData?.background;
  const items = blockData?.items;
  const classes = useStyles(background)();

  return (
    <Box
      className={cx(
        classes.wrapper,
        background === 'Dark' ? 'dark-block' : 'light-block',
        'contact-details-block',
      )}
    >
      <Container className={classes.container}>
        <Box className={classes.detailsBox}>
          {items?.map((item) => {
            const heading = item?.heading;
            const icon = item?.icon_url;
            const content = item?.editable_html || '';
            const typeContent = item?.type_content;

            return (
              <Box key={heading} className={cx(classes.detailBox, 'details-block')}>
                <Box className={classes.detailBoxImage}>
                  <IKImage
                    path={icon}
                    alt={heading}
                    draggable={false}
                    srcset={[{ width: 50 }, { width: 72 }]}
                    sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 50px, 72px`}
                  />
                </Box>
                <Box className={classes.detailBoxContent}>
                  <Typography
                    variant="h4"
                    component="h4"
                    align="left"
                    className={cx(classes.detailBoxTitle, 'details-title')}
                  >
                    {heading}
                  </Typography>
                  {typeContent === SocialItemTypes.SocialMedia ? (
                    <Links>
                      {Object.entries(links).map(([key, value]) => {
                        const link = tenant[key];
                        const IconComponent = value;
                        return (
                          Boolean(link) && (
                            <SocialLink
                              key={key}
                              href={link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconComponent color={alpha(colorsPalette.white, 0.33)} />
                            </SocialLink>
                          )
                        );
                      })}
                    </Links>
                  ) : (
                    <Box className={classes.detailBoxDescription}>{parse(content)}</Box>
                  )}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};

export default ContactDetailsBlock;

const styleIcon = (icon) =>
  styled(icon)({
    color: alpha(colorsPalette.white, 0.33),
    width: 24,
  });
const Links = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  marginTop: SMALL_MARGIN,
});
const StyledInstagram = styleIcon(InstagramIcon);
const StyledFacebook = styleIcon(FacebookIcon);
const StyledTwitter = styleIcon(TwitterIcon);
const StyledLinkedin = styleIcon(LinkedInIcon);
const SocialLink = styled('a')({
  '&:not(:last-child)': {
    marginRight: SMALL_MARGIN,
  },
});
const links = {
  instagram_link: StyledInstagram,
  linkedin_link: StyledLinkedin,
  twitter_link: StyledTwitter,
  facebook_link: StyledFacebook,
};
